<template>
  <div class="intangibleLocation-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           :mask-closable='false'
           :title="title"
           @on-ok="createintangibleLocation('intangibleLocationValidate')"
           :loading="loading">
      <Form :model="intangibleLocation"
            ref="intangibleLocationValidate"
            :label-width="60"
            :rules="intangibleLocationValidate"
            action="javascript:void(0)">
        <FormItem label="地图标题"
                  prop="title">
          <Input v-model="intangibleLocation.title"
                 placeholder="最多5个汉字"></Input>
        </FormItem>
        <FormItem label="经度"
                  prop="lat">
          <Input v-model="intangibleLocation.lng"
                 placeholder="输入经度..."></Input>
          <a href="https://lbs.amap.com/console/show/picker"
             target="_blank">拾取经纬度，大的是经度</a>
        </FormItem>
        <FormItem label="纬度"
                  prop="lng">
          <Input v-model="intangibleLocation.lat"
                 placeholder="输入纬度名称..."></Input>
          <a href="https://lbs.amap.com/console/show/picker"
             target="_blank">拾取经纬度，小的是纬度</a>
        </FormItem>
        <FormItem label="地址状态"
                  prop="display">
          <RadioGroup v-model="bigAuthStatus">
            <Radio label="已认证"></Radio>
            <Radio label="未认证"></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="状态"
                  prop="display">
          <RadioGroup v-model="bigStatus">
            <Radio label="正常"></Radio>
            <Radio label="禁用"></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="匠人"
                  prop="display">
          <Select v-model="tradesmanIds"
                  multiple
                  clearable
                  filterable
                  placeholder="选择匠人">
            <Option v-for="item in tradesManList"
                    :value="item.id"
                    :key="item.id">{{item.nickname}}</Option>
          </Select>
        </FormItem>
        <FormItem label="添加外链">
          <List>
            <ListItem v-for="(item,key) in externalLinksList">
              <Input v-model="externalLinksList[key]['title']"
                     placeholder="链接标题..."></Input>
              <Input v-model="externalLinksList[key]['link_url']"
                     placeholder="链接地址..."></Input>
              <template slot="action">
                <li>
                  <Button type="error"
                          @click="deleteExternalLinks(key)">删除</Button>
                </li>
              </template>
            </ListItem>
          </List>
          <Button type="success"
                  @click="externalLinksList.push({title:'', link_url:''})"
                  long>增加链接</Button>
        </FormItem>
        <!-- 改成一种类型的链接了, 注掉类型外链 -->
        <!-- <FormItem label="添加类型外链">
                    <List>
                        <ListItem v-for="(item,key) in typeLinksList">
                            <Input v-model="typeLinksList[key]['title']" placeholder="链接标题..."></Input>
                            <Input v-model="typeLinksList[key]['link_url']" placeholder="链接地址..."></Input>
                            <template slot="action">
                                <li>
                                    <Button type="error" @click="deleteTypeLinks(key)">删除</Button>
                                </li>
                            </template>
                        </ListItem>
                    </List>
                    <Button type="success" @click="typeLinksList.push({title:'', link_url:''})" long>增加链接</Button>
                </FormItem> -->
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'intangibleLocation-list',
  data () {
    return {
      loading: true,
      dataloading: true,
      thumblist: [],
      datePic: [],
      cateList: [],
      externalLinksList: [],
      typeLinksList: [],
      tradesManList: [],
      statusList: [{ id: 1, name: '正常' }, { id: 0, name: '禁用' }],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: '',
      formItem: {
        'key': '',
      },
      bigDisplay: '',
      list: [
        {
          title: 'Id',
          key: 'id',
          fixed: 'left',
          width: 90
        },
        {
          title: '标题',
          key: 'title',
          minWidth: 200,
        },
        {
          title: '地址',
          key: 'diqu',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('p', {
                style: {
                  color: '#8a6d3b'
                }
              }, '经度:' + params.row.lng),
              h('p', {
                style: {
                  color: '#777'
                }
              }, '纬度:' + params.row.lat)
            ]);
          }
        },
        {
          title: '认证状态',
          key: 'title',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.auth_status == 1 ? '已认证' : '未认证')
            ]);
          }
        },
        {
          title: '状态',
          key: 'title',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h('span', {}, params.row.status == 1 ? '正常' : '禁用')
            ]);
          }
        },
        {
          title: '修改时间',
          key: 'updated_at',
          width: 150,
        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.detail(params.index, params.row.id)
                  }
                }
              }, '编辑'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.index, params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      tablelist: [],
      intangibleLocation: {
        name: '',
        status: true,
      },
      showModalStatus: false,
      intangibleLocationValidate: {
        title: [
          { required: true, message: '标题必须填写', trigger: 'blur' }
        ],
        lat: [
          { required: true, message: '经度填写', trigger: 'blur' }
        ],
        lng: [
          { required: true, message: '纬度填写', trigger: 'blur' }
        ]

      },
      params: {
        datetime: [],
      },
      typeList: [],
      bigAuthStatus: "未认证",
      bigStatus: "禁用",
      id: 0,
      tradesmanIds: []
    }
  },
  created: function () {
    // 取数据
    this.id = this.$route.params.id
    this.init();
  },
  methods: {
    init (id) {
      this.getTableList();
      this.getCateList();
      this.getTypeList();
      this.getTradesMansList();
    },
    getTableList: function (id) {
      this.$api.intangibleLocation.list({
        id: this.id,
        "page": this.pages.page,
        "size": this.pages.size
      }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    getTradesMansList () {
      this.$api.intangibleLocation.trades({ page: 1, size: 9999999 }).then(res => {
        if (res.code == 200) {
          this.tradesManList = res.result;
          // console.log(this.tradesManList);
        }
      });
      return;
    },
    getCateList () {
      this.$api.intangibleCate.list({ page: 1, size: 999 }).then(res => {
        if (res.code == 200) {
          this.cateList = res.result.list;
        }
      });
    },
    getTypeList () {
      this.$api.intangibleLevel.type({ page: 1, size: 999 }).then(res => {
        if (res.code == 200) {
          this.typeList = res.result;
        }
      });
    },
    // 展开添加
    showModel () {
      this.title = "添加定位点";
      this.intangibleLocation = {
        title: '',
      };
      this.externalLinksList = [];
      this.typeLinksList = [];
      this.bigAuthStatus = "未认证";
      this.bigStatus = "禁用";
      this.showModalStatus = !this.showModalStatus;
    },
    // 详情
    detail (index, id) {
      this.title = "编辑定位点";
      this.intangibleLocation = {
        title: '',
      };
      this.tradesmanIds = []
      this.externalLinksList = [];
      this.typeLinksList = [];
      this.thumblist = new Array();
      this.$refs['intangibleLocationValidate'].resetFields();
      this.showModalStatus = !this.showModalStatus;
      this.$api.intangibleLocation.detail({ id: id }).then(res => {
        this.intangibleLocation = res.result;
        this.externalLinksList = res.result.externalLinksList;
        this.typeLinksList = res.result.external_links;
        this.bigAuthStatus = "未认证";
        this.bigStatus = "禁用";
        // this.tradesmanIds = res.result.tradesman_id

        for (let i = 0; i < res.result.tradesmanlocations.length; i++) {
          const trade = res.result.tradesmanlocations[i];
          this.tradesmanIds.push(trade.tradesman_id)
        }
        if (this.intangibleLocation.auth_status == 1)
          this.bigAuthStatus = '已认证';
        if (this.intangibleLocation.status == 1)
          this.bigStatus = '正常';
      });
    },
    // 添加
    createintangibleLocation (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.intangibleLocation.auth_status = 0;
          if (this.bigAuthStatus == '已认证') {
            this.intangibleLocation.auth_status = 1;
          }
          this.intangibleLocation.status = 0;
          if (this.bigStatus == '正常') {
            this.intangibleLocation.status = 1;
          }
          this.intangibleLocation.tradesman_ids = this.tradesmanIds;
          this.intangibleLocation.intangible_id = this.id;
          this.intangibleLocation.external_links = this.externalLinksList;
          this.intangibleLocation.typeLinksList = this.typeLinksList;
          console.log(this.typeLinksList)
          if (this.intangibleLocation.id == null || this.intangibleLocation.id == 0) {
            this.$api.intangibleLocation.create(this.intangibleLocation).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.intangibleLocation.edit(this.intangibleLocation).then(res => {
              console.log(this.intangibleLocation);
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          }
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      })
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.intangibleLocation.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.tablelist.splice(index, 1);
            }
          });
        }
      });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.intangibleLocation.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var bgn_date = this.params.datetime[0] != undefined ? this.params.datetime[0] : '';
      var end_date = this.params.datetime[1] != undefined ? this.params.datetime[1] : '';
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status,
        type_id: this.formItem.type_id,
        cate_id: this.formItem.cate_id,
        starttime: bgn_date,
        endtime: end_date,
      };
      this.$api.intangibleLocation.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },

    //删除外链
    deleteExternalLinks (key) {
      if (this.externalLinksList[key] == "") {
        this.externalLinksList.splice(key, 1);
      } else {
        this.$Modal.confirm({
          title: "删除外链确认",
          content: "<p>此外链已编辑，是否删除？</p>",
          onOk: () => {
            this.externalLinksList.splice(key, 1);
          },
          onCancel: () => {
            // this.$Message.info('Clicked cancel');
          }
        });
      }
    },
    //删除分类链接
    deleteTypeLinks (key) {
      if (this.typeLinksList[key] == "") {
        this.typeLinksList.splice(key, 1);
      } else {
        this.$Modal.confirm({
          title: "删除外链确认",
          content: "<p>此类型外链已编辑，是否删除？</p>",
          onOk: () => {
            this.typeLinksList.splice(key, 1);
          },
          onCancel: () => {
            // this.$Message.info('Clicked cancel');
          }
        });
      }
    },
  },
}
</script>
